export const COURSE_PEOPLE = { visibleCount: 3, initialsLength: 2 } as const;

export const COURSE_AVATAR = {
  border:
    "shrink-0 rounded-full border border-[#98A2B3] text-[#344054] font-semibold",
  fallback: "bg-[#F2F4F7] text-[#344054]",
  logo: "object-contain p-1",
} as const;
